import styled from 'styled-components';
import { TiLocationOutline, TiMail } from "react-icons/ti";
import bannerBg from "../../assets/images/banner-bg.png";

export const HomeIcon = styled(TiLocationOutline)`
  width: 6rem;
  height: 6rem; 
  color: #efadb3;

  @media (min-width: 1100px) {
      margin-right: 2rem;
  }
`;

export const MailIcon = styled(TiMail)`
  width: 6rem;
  height: 6rem;
  color: #efadb3;

  @media (min-width: 1100px) {
      margin-right: 2rem;
  }
`;

export const Container = styled.div`
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0.3rem 0 0.3rem 0;
  background-color: #fff;
`;

export const Address = styled.div`
  display: flex;
  padding: 4rem;

  h1 {
    font-size: 2rem;
  }
`;

export const Email = styled.div`
  display: flex;
  padding: 4rem;
  align-items: center;

  p {
    font-size: 2.5rem;
  }
`;

export const Banner = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 16rem;
  background-image: url(${bannerBg});
  background-size: auto;  
  background-color: #294c7c;
 
  h1 {
    font-family: Merengue;
    font-size: 8rem;
    color: #fff;

    @media (min-width: 1100px) {
      font-size: 11rem;
    }
  }

  @media (min-width: 1100px) {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    h1 {
      font-size: 11rem;
     }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-items: center;

  @media (min-width: 1100px) {
    flex-direction: row;
  }
`;

export const Column = styled.div`  

`;

export const TextColumn = styled.div`  
  width: 450px;
  text-align: center;

  @media (min-width: 1100px) {
    text-align: left;
  }
`;